import axios from 'axios';
import { TempGateGateway } from '../../corelogic/domain/ports/tempGateway.port';
import { getSecureRequestHeaders } from '../../corelogic/domain/utils/securityHeaders.utils';

export class ApiTempGateGateway implements TempGateGateway {
  private apiEndpoint: string;

  constructor(apiEndpoint: string) {
    this.apiEndpoint = apiEndpoint;
  }

  async verifyAppPassword(password: string): Promise<boolean> {
    console.log('API endpoint:', this.apiEndpoint);
    try {
      const response = await axios.post(
        `${this.apiEndpoint}/verify-app-password`,
        {
          password,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            ...getSecureRequestHeaders(),
          },
        },
      );

      return response.data.success === true;
    } catch (error) {
      console.error('Error verifying app password:', error);
      return false;
    }
  }
}
